<template>
  <div class="nav-dropdown-item">
    {{ item.title }}
    <div class="vocaline" :style="{ background: backgroundLine }"></div>
  </div>
</template>

<script>
export default {
  name: 'NavDropdownItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    backgroundLine: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style scoped lang="scss">
.nav-dropdown-item {
  color: #000;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  .vocaline {
    width: 0;
    height: 2px;
    margin: 10px auto 0;
    background: #fff;
    transition: all 0.5s ease-in-out;
  }

  &:hover {
    .vocaline {
      width: 50%;
      margin: 10px auto 0;
    }
  }
}
</style>